/**
 * Cookie utility functions for EVOP Inspector
 */

/**
 * Get a cookie value by name
 * @param name The cookie name to retrieve
 * @returns The cookie value or null if not found
 */
export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null
  }

  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  
  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(';').shift()
    return cookieValue ? decodeURIComponent(cookieValue) : null
  }
  
  return null
}

/**
 * Get the CSRF token from cookies
 * @returns The CSRF token or null if not found
 */
export function getCSRFToken(): string | null {
  return getCookie('evop_inspector_csrf_token')
}